import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Grid2, Paper, Box, Typography } from "@mui/material";

import { Divider } from "components/Divider";

import { i18n } from "services/i18nService";
import { addGoogleTagManager } from "services/utility/googleTagManager";
import { isBetaEnvironment } from "services/utility/misc";

import { Footer } from "views/Trial/Footer";
import { PlanSelection } from "views/Trial/PlanSelection";
import { TrialSignup } from "views/Trial/TrialSignup";

const sx = {
  paper: { p: 2, width: "100%", height: "100%" },
  background: {
    minHeight: "100vh",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    "& img": { width: "75px" },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export function Trial() {
  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);
  const plan = queryParams.get("plan");

  const showTrialSignup = Boolean(plan);

  useEffect(() => {
    // add Google Tag Manager to capture the signup data in Google Analytics
    isBetaEnvironment && addGoogleTagManager();
  });

  return (
    <Grid2 container spacing={0} sx={sx.background}>
      <Paper sx={sx.paper} elevation={5}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Box sx={sx.logo}>
            <img alt="SOS Inventory Logo" src="/images/sos_graphic.svg"></img>
          </Box>
          {showTrialSignup ? (
            <Typography variant="h2">
              {i18n("trial.Signup.title.1")} {plan}{" "}
              {i18n("trial.Signup.title.2")}. {i18n("trial.Signup.title.3")}
            </Typography>
          ) : (
            <Typography variant="h2">{i18n("trial.Title")}</Typography>
          )}
        </Box>
        <Divider margin="1rem 0" />
        {showTrialSignup ? <TrialSignup plan={plan} /> : <PlanSelection />}
        <Divider margin="1rem 0" />
        <Footer />
      </Paper>
    </Grid2>
  );
}
